
(function() {
  function initAlloMobileBuy(){
    var bar=document.querySelector('[data-allo-mobile-buy]');
    if(!bar||bar.dataset.ready==='true')return;
    bar.dataset.ready='true';
    var button=bar.querySelector('.allo-mobile-buy__action');
    var primary=document.querySelector('.product-information product-form-component .add-to-cart-button');
    if(!primary)return;
    function sync(){
      button.disabled=!!primary.disabled;
      button.textContent=primary.disabled?'Indisponible':'Ajouter au panier';
    }
    sync();
    button.addEventListener('click',function(){
      sync();
      if(!button.disabled)primary.click();
    });
    if('MutationObserver' in window){
      var mutation=new MutationObserver(sync);
      mutation.observe(primary,{attributes:true,attributeFilter:['disabled','aria-disabled']});
    }
    // Consistent visibility after manual scrolling, fast jumps and Shopify preview changes.
    var visibilityFrame=0;
    function updateVisibility(){
      visibilityFrame=0;
      var isMobile=window.matchMedia('(max-width: 749px)').matches;
      var passedOriginalButton=primary.getBoundingClientRect().bottom < 0;
      bar.classList.toggle('is-visible',isMobile && passedOriginalButton);
    }
    function scheduleVisibility(){
      if(!visibilityFrame)visibilityFrame=window.requestAnimationFrame(updateVisibility);
    }
    window.addEventListener('scroll',scheduleVisibility,{passive:true});
    window.addEventListener('resize',scheduleVisibility,{passive:true});
    window.addEventListener('load',scheduleVisibility,{once:true});
    scheduleVisibility();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initAlloMobileBuy);else initAlloMobileBuy();
  document.addEventListener('shopify:section:load',initAlloMobileBuy);
})();

/* Choice 2: relocate the original Shopify purchase form */
(function(){
  function mountChoice2(){
    var section=document.querySelector('.product-information');
    if(!section)return;
    var aside=section.querySelector('[data-allo-choice2-sidebar]');
    var slot=section.querySelector('[data-allo-purchase-slot]');
    var original=section.querySelector('.product-details .buy-buttons-block');
    if(!aside||!slot||!original||section.dataset.alloChoice2Ready==='true')return;
    section.dataset.alloChoice2Ready='true';
    var placeholder=document.createComment('AlloSwitch native product form position');
    original.parentNode.insertBefore(placeholder,original);
    // The reference layout puts the native Shopify form inside the purchase panel on every screen.
    if(original.parentNode!==slot)slot.appendChild(original);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mountChoice2);else mountChoice2();
  document.addEventListener('shopify:section:load',mountChoice2);
})();

/* AlloSwitch screenshot layout: real tabs, local favourites and share. */
(function(){
 function initExact(){
  document.querySelectorAll('[data-allo-tabs]').forEach(function(nav){
   if(nav.dataset.ready)return;nav.dataset.ready='1';
   var parent=nav.closest('.allo-exact-details'),items=[].slice.call(parent.querySelectorAll('.allo-exact-pane'));
   nav.querySelectorAll('[data-allo-tab]').forEach(function(button){
    button.addEventListener('click',function(){
     var id=button.getAttribute('data-allo-tab');
     nav.querySelectorAll('[data-allo-tab]').forEach(function(b){b.classList.toggle('active',b===button);b.setAttribute('aria-pressed',b===button?'true':'false')});
     items.forEach(function(it){it.open=(it.id===id)});
    });
   });
  });

 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initExact);else initExact();
 document.addEventListener('shopify:section:load',initExact);
})();

/* AlloSwitch remarks: expand product description without duplicating its content. */
(function(){
  function initReadMore(){
    document.querySelectorAll('[data-allo-read-more]').forEach(function(button){
      if(button.dataset.alloReady==='1')return;
      button.dataset.alloReady='1';
      var wrapper=button.parentElement.querySelector('[data-allo-product-copy]');
      if(!wrapper)return;
      button.addEventListener('click',function(){
        var open=wrapper.classList.toggle('is-expanded');
        button.setAttribute('aria-expanded',String(open));
        button.innerHTML=open?'Réduire la description <span aria-hidden="true">⌃</span>':'Lire la description complète <span aria-hidden="true">⌄</span>';
      });
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initReadMore);else initReadMore();
  document.addEventListener('shopify:section:load',initReadMore);
})();

/* AlloSwitch Judge.me navigation: scroll to actual product reviews rather than placeholder. */
(function(){
  function initReviewNavigation(){
    document.querySelectorAll('a[href="#judgeme_product_reviews"]').forEach(function(link){
      if(link.dataset.alloReviewReady)return;
      link.dataset.alloReviewReady='1';
      link.addEventListener('click',function(event){
        var widget=document.getElementById('judgeme_product_reviews');
        if(!widget)return;
        event.preventDefault();
        var hash='#judgeme_product_reviews';
        if(window.history && window.history.replaceState){
          window.history.replaceState(window.history.state,'',window.location.pathname+window.location.search+hash);
        }
        // Instant navigation overrides the theme's slow global smooth-scrolling behavior.
        var top=widget.getBoundingClientRect().top+window.scrollY-80;
        window.scrollTo({top:Math.max(0,top),behavior:'instant'});
      });
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initReviewNavigation);
  else initReviewNavigation();
  document.addEventListener('shopify:section:load',initReviewNavigation);
})();
